import {PaymentMethodController} from "./flows/PaymentMethodController.js";
import {SubscriptionPlanController} from "./flows/SubscriptionPlanController.js";
import {AddressController} from "./flows/AddressController.js";


// These are instantiated in the flow state classes and throughout the inline user dashboard
export const Controller = {
    paymentMethod: new PaymentMethodController(),
    subscriptionPlan: new SubscriptionPlanController(),
    address: new AddressController(),
}
